module.exports = __webpack_public_path__ + "img/img-44.1e3cfe22.png";